// @flow
import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import { Button } from '@mui/material';
import { formatUnixTimestamp } from 'utils/dateFormat';

function allMachines({ data, guardActionRequest }) {
  return (
    <Card>
      <CardContent>
        <Typography component="div" sx={{ fontSize: 14 }} marginBottom={5} color="text.secondary" gutterBottom>
          Latest logs/events
          <Chip label="Real time logs/events" style={{ float: 'right' }} />
        </Typography>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '1rem', justifyContent: 'space-between' }}>
          {data &&
            data.map((row) => (
              <Card key={row.id} variant="outlined" sx={{ marginBottom: 2 }}>
                <CardContent>
                  <Typography variant="body2" component="div">
                    <strong>Vehicle Number:</strong> {row.vehicleNumber}
                  </Typography>
                  <Typography variant="body2" component="div">
                    <strong>Pit Number:</strong> {row.pitNumber}
                  </Typography>
                  <Typography variant="body2" component="div">
                    <strong>Balance Load:</strong> {row.balancedLoad} MT
                  </Typography>
                  <Typography variant="body2" component="div">
                    <strong>Crusher Name:</strong> {row.customer}
                  </Typography>
                  <Typography variant="body2" component="div">
                    <strong>Weighbridge Number:</strong> {row.weighBridgeNumber}
                  </Typography>
                  <Typography variant="body2" component="div">
                    <strong>Entry Time:</strong> {formatUnixTimestamp(row.loggedInTime)}
                  </Typography>
                  <div style={{ marginTop: '1rem' }}>
                    <Button
                      variant="contained"
                      color="success"
                      style={{
                        padding: '5px 10px',
                        marginRight: '5px',
                        borderRadius: '4px',
                        fontSize: '12px',
                      }}
                      onClick={() => guardActionRequest(row.id, 'check-in', row.pitNumber)}
                      disabled={row.guardCheckIn > 0}
                    >
                      Entry
                    </Button>
                    <Button
                      variant="contained"
                      color="error"
                      style={{
                        padding: '5px 10px',
                        borderRadius: '4px',
                        fontSize: '12px',
                      }}
                      onClick={() => guardActionRequest(row.id, 'check-out', row.pitNumber)}
                      disabled={row.guardCheckIn < 0 || row.guardCheckOut > 0}
                    >
                      Exit
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
        </div>
      </CardContent>
    </Card>
  );
}

export default allMachines;
